const ICONS = "/iceholidays-assets/images/icons";

const CATEGORY_LOGOS: Record<string, string> = {
  "GD Standard": `${ICONS}/gd.png`,
  "FS": `${ICONS}/fs.png`,
  "GD Premium": `${ICONS}/premium.png`,
  "GD Domestic": `${ICONS}/gd_domestic.png`,
  "GD Signature": `${ICONS}/gd_signature.png`,
  "GD FLY CRUISE": `${ICONS}/fly_cruise.png`,
};

export const brandLogoForCategory = (category?: string): string | undefined => {
  if (!category) return undefined;
  if (CATEGORY_LOGOS[category]) return CATEGORY_LOGOS[category];
  if (category.includes("CRUISE")) return `${ICONS}/cruise.png`;
  if (category.includes("GD In Depth")) return `${ICONS}/gd.png`;
  return undefined;
};

export const BRAND_FILTER_LOGOS: Record<string, string> = {
  GD_Standard: `${ICONS}/gd.png`,
  GD_Signature: `${ICONS}/gd_signature.png`,
  GD_In_Depth: `${ICONS}/gd.png`,
  FS: `${ICONS}/fs.png`,
  CRUISE: `${ICONS}/cruise.png`,
  GD_FLY_CRUISE: `${ICONS}/fly_cruise.png`,
};

export const BRAND_FILTER_DESCRIPTIONS: Record<string, string> = {
  GD_Standard: "GD Classic offers hassle-free classic tours to popular destinations, with iconic attractions, well-paced itineraries, quality stays, and reliable support for a smooth and enjoyable journey.",
  GD_Signature: "The Signature Tours crafts distinctive luxury journeys with boutique stays, cultural experiences, and refined service.",
  GD_In_Depth: "GD In-Depth offers immersive journeys beyond sightseeing, connecting you with local culture and daily life.",
  FS: "FS Holidays offers value-for-money tours with flexible itineraries, combining must-see attractions and free time for a relaxed and memorable journey.",
  CRUISE: "GD World Cruises offers exciting cruise packages from Port Klang, Malacca, and Singapore, featuring cruise cabins and themed cruises for your perfect sea getaway.",
  GD_FLY_CRUISE: "GD FlyCruise offers global cruise journeys with flights, accommodation, and land experiences, supported by a tour leader for a seamless experience.",
};
